import '../../endpoints/basic/valueUnit/get.module.js';
import '../../endpoints/index/constituents/list.module.js';
import { InstrumentGetByNotationModuleFactory } from '../../endpoints/instrument/getByNotation.module.js';
import '../../endpoints/instrument/crossreference.module.js';
import '../../endpoints/instrument/coupon/keyData/get.module.js';
import '../../endpoints/instrument/exchangeRate/getByISOCode.module.js';
import '../../endpoints/notation/crossReference/listByInstrument.module.js';
import '../../endpoints/notation/keyFigures/get.module.js';
import '../../endpoints/notation/get.module.js';
import '../../endpoints/prices/list.module.js';
import '../../endpoints/debtInstrument/get.module.js';
import '../../endpoints/legalEntity/company/get.module.js';
import '../../endpoints/legalEntity/address/list.module.js';
import '../../endpoints/news/article/get.module.js';
import '../../endpoints/news/article/searchByText.module.js';
import '../../endpoints/fund/shareClass/get.module.js';
import '../../endpoints/instrument/benchmark/list.module.js';
import '../../endpoints/prices/bidAsk/list.module.js';
import '../../endpoints/securitizedDerivative/get.module.js';
import '../../endpoints/company/keyItems/fiscalYear/listByInstrument.module.js';
import { InstrumentCategoryListModuleFactory } from '../../endpoints/instrument/category/list.module.js';
import '../../endpoints/securitizedDerivative/keyFigures/notation/get.module.js';
import '../../endpoints/notation/searchByText.module.js';
import '../../endpoints/prices/timeSeries/eod/list.module.js';
import '../../endpoints/prices/timeSeries/intraday/subsample/list.module.js';
import '../../endpoints/company/board/listByInstrument.module.js';
import '../../endpoints/prices/orderbook/aggregated/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/get.module.js';
import '../../endpoints/company/estimates/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/benchmark/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/type/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/performance/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/fee/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/manager/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/riskFigures/listByInstrument.module.js';
import '../../endpoints/stock/owner/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/evaluation/getByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/holding/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/issuer/search.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/issuer/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/eod/ranking/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/intraday/ranking/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/type/list.module.js';
import '../../endpoints/securitizedDerivative/notation/screener/search.module.js';
import '../../endpoints/basic/market/list.module.js';
import '../../endpoints/basic/language/list.module.js';
import '../../endpoints/basic/valueUnit/currency/main/list.module.js';
import '../../endpoints/basic/frequency/type/list.module.js';
import '../../endpoints/legalEntity/list.module.js';
import '../../endpoints/instrument/coupon/interestRate/type/list.module.js';
import '../../endpoints/instrument/backgroundText/listByInstrument.module.js';
import '../../endpoints/stock/recommendation/aggregate/history/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/investmentFocus/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/exchange/list.module.js';
import '../../endpoints/stock/notation/ranking/intraday/list.module.js';
import '../../endpoints/notation/status/get.module.js';
import '../../endpoints/instrument/complianceProperty/listByInstrument.module.js';
import '../../endpoints/vendor/tradingCentral/technicalAnalysis/list.module.js';
import '../../endpoints/vendor/tradingCentral/technicalAnalysis/get.module.js';
import '../../endpoints/calendarEvent/list.module.js';
import '../../endpoints/calendarEvent/get.module.js';
import '../../endpoints/stock/notation/screener/search.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/figure/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/ranking/listByInstrument.module.js';
import '../../endpoints/news/article/listByMediaKind.module.js';
import '../../endpoints/documents/searchByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/narrative/get.module.js';
import '../../endpoints/debtInstrument/keyFigures/notation/get.module.js';
import '../../endpoints/securitizedDerivative/notation/ranking/intraday/list.module.js';
import '../../endpoints/notation/keyFigures/list.module.js';
import '../../endpoints/instrument/legalEntity/backgroundText/listByInstrument.module.js';
import '../../endpoints/securitizedDerivative/underlying/list.module.js';
import '../../endpoints/basic/market/get.module.js';
import '../../endpoints/securitizedDerivative/issuer/search.module.js';
import '../../endpoints/prices/tradingSchedule/event/list.module.js';
import '../../endpoints/debtInstrument/issuer/search.module.js';
import '../../endpoints/debtInstrument/notation/screener/search.module.js';
import '../../endpoints/watchlist/create.module.js';
import '../../endpoints/watchlist/delete.module.js';
import '../../endpoints/watchlist/list.module.js';
import '../../endpoints/watchlist/get.module.js';
import '../../endpoints/watchlist/modify.module.js';
import '../../endpoints/watchlist/position/create.module.js';
import '../../endpoints/watchlist/position/delete.module.js';
import '../../endpoints/watchlist/position/list.module.js';
import '../../endpoints/watchlist/position/get.module.js';
import '../../endpoints/watchlist/position/modify.module.js';
import '../../endpoints/basic/region/list.module.js';
import '../../endpoints/portfolio/transaction/list.module.js';
import '../../endpoints/portfolio/list.module.js';
import { PortfolioPositionListModuleFactory } from '../../endpoints/portfolio/position/list.module.js';
import { PortfolioGetModuleFactory } from '../../endpoints/portfolio/get.module.js';
import '../../endpoints/portfolio/create.module.js';
import '../../endpoints/portfolio/modify.module.js';
import '../../endpoints/portfolio/delete.module.js';
import '../../endpoints/portfolio/transaction/create.module.js';
import '../../endpoints/portfolio/transaction/delete.module.js';
import '../../endpoints/portfolio/transaction/modify.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/screener/search.module.js';
import '../../endpoints/basic/region/country/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/element/list.module.js';
import '../../endpoints/instrument/get.module.js';
import '../../endpoints/portfolio/evaluation/list.module.js';
import '../../endpoints/stock/recommendation/aggregate/get.module.js';
import '../../endpoints/prices/timeSeries/eod/subsample/get.module.js';
import '../../endpoints/category/listBySystem.module.js';
import '../../endpoints/alerting/prices/basic/alert/get.module.js';
import '../../endpoints/alerting/prices/basic/alert/list.module.js';
import '../../endpoints/alerting/prices/basic/alert/delete.module.js';
import '../../endpoints/alerting/prices/basic/trigger/create.module.js';
import '../../endpoints/alerting/prices/basic/trigger/delete.module.js';
import '../../endpoints/alerting/prices/basic/trigger/get.module.js';
import '../../endpoints/alerting/prices/basic/trigger/list.module.js';
import '../../endpoints/alerting/prices/basic/trigger/modify.module.js';
import '../../endpoints/company/logo/get.module.js';
import '../../endpoints/product/wmp/portfolioAnalytics/allocation/assetClass/list.module.js';
import '../../endpoints/product/wmp/portfolioAnalytics/allocation/sector/list.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/managers/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/benchmarkDetails/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/summary/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/classifications/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/costsFees/get.module.js';
import '../../endpoints/factset/content/factsetOwnership/v1/fundHoldings/get.module.js';
import '../../endpoints/fund/holding/listByInstrument.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/returnsSnapshot/get.module.js';
import '../../endpoints/factset/content/factsetEsg/sasbScores/get.module.js';
import '../../endpoints/factset/content/factsetEsg/sasbScoresAll/get.module.js';
import '../../endpoints/product/widgets/portfolio/performance/annualizedTotalReturn/list.module.js';
import '../../endpoints/product/widgets/portfolio/performance/cumulativeTotalReturn/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/esg/getByInstrument.module.js';
import '../../endpoints/fund/breakdown/position/ListByInstrument.module.js';
import '../../endpoints/product/widgets/portfolio/holdings/list.module.js';
import '../../endpoints/product/widgets/portfolio/weights/list.module.js';
import '../../endpoints/product/widgets/portfolio/characteristics/list.module.js';
import '../../endpoints/product/widgets/portfolio/performance/attribution/list.module.js';
import '../../endpoints/notation/crossReference/listBySymbol.module.js';
import '../../endpoints/notation/crossReference/listByISIN.module.js';
import '../../endpoints/instrument/notation/list.module.js';
import '../../endpoints/factset/content/factsetGeorev/v1/countries/get.module.js';
import '../../endpoints/news/article/type/list.module.js';
import '../../endpoints/news/publisher/list.module.js';
import '../../endpoints/category/system/list.module.js';
import '../../endpoints/news/distributor/list.module.js';
import '../../endpoints/factset/content/factsetGeorev/v1/regions/get.module.js';
import '../../endpoints/product/widgets/portfolio/performance/discreteTotalReturn/list.module.js';
import '../../endpoints/index/get.module.js';
import '../../endpoints/fund/notation/screener/search.module.js';
import '../../endpoints/basic/valueUnit/list.module.js';
import '../../endpoints/fund/issuer/search.module.js';
import '../../endpoints/rating/grade/listBySystem.module.js';
import '../../endpoints/fund/notation/screener/valueRanges/get.module.js';
import { getLanguage, mapAssetClass, getPercentage, getEndpointOptions } from '../../helpers/common.js';
import 'lodash.set';
import { Mdg2StoreModuleFactory } from '../../abstracts/Mdg2StoreModuleFactory.js';
import '../../abstracts/Mdg2EndpointStoreModuleFactory.js';
import '../../abstracts/Mdg2SubscriptionStoreModuleFactory.js';
import 'vue';
import 'lodash.matches';

class PortfolioBreakdownStoreModuleFactory extends Mdg2StoreModuleFactory {
  constructor() {
    super(...arguments);
    this.datasetId = 14;
    this.defaultLanguage = "en";
    this.defaultInstrumentCategoryListName = "Other";
  }
  getPortfolioPositionListRequest(id) {
    return { id };
  }
  getPortfolioPositionListData(payload) {
    var _a;
    const request = this.getPortfolioPositionListRequest(payload.id);
    const response = this.getEndpoints().portfolioPositionList.getData(request);
    return (_a = response == null ? void 0 : response.data) != null ? _a : null;
  }
  getNotationId(position) {
    if (!position.notation.id) {
      throw new Error("Could not fetch position id");
    }
    return position.notation.id;
  }
  getPositionInstrumentId(position) {
    if (!position.instrument.id) {
      throw new Error("Could not fetch instrument id");
    }
    return position.instrument.id;
  }
  getInstrumentGetByNotationRequest(id, payloadLanguage) {
    return { id, _language: getLanguage(payloadLanguage, this.defaultLanguage, this.options) };
  }
  getInstrumentGetByNotationData(payload, position) {
    var _a;
    try {
      const idNotation = this.getNotationId(position);
      const request = this.getInstrumentGetByNotationRequest(idNotation, payload.language);
      const response = this.getEndpoints().instrumentGetByNotation.getData(request);
      return (_a = response == null ? void 0 : response.data) != null ? _a : null;
    } catch (error) {
      return null;
    }
  }
  getInstrumentCategoryListRequest(instrumentId, payloadLanguage) {
    return {
      data: {
        id: instrumentId,
        filter: {
          dataset: {
            id: this.datasetId
          }
        }
      },
      meta: {
        language: getLanguage(payloadLanguage, this.defaultLanguage, this.options)
      }
    };
  }
  getInstrumentCategoryListName(payload, position) {
    var _a;
    try {
      const positionInstrumentId = this.getPositionInstrumentId(position);
      const request = this.getInstrumentCategoryListRequest(positionInstrumentId, payload.language);
      const response = this.getEndpoints().instrumentCategoryList.getData(request);
      return (_a = response == null ? void 0 : response.data[0].categories[1].name) != null ? _a : this.defaultInstrumentCategoryListName;
    } catch (error) {
      return this.defaultInstrumentCategoryListName;
    }
  }
  getPortfolioPositions(payload) {
    var _a;
    const portfolioPositionListData = this.getPortfolioPositionListData(payload);
    return ((_a = portfolioPositionListData == null ? void 0 : portfolioPositionListData.positions) != null ? _a : []).map((position) => {
      var _a2, _b, _c;
      const instrumentByNotationData = this.getInstrumentGetByNotationData(payload, position);
      const code = instrumentByNotationData == null ? void 0 : instrumentByNotationData.assetClass.code;
      const sectorName = this.getInstrumentCategoryListName(payload, position);
      return {
        assetClass: mapAssetClass(code),
        marketValue: (_a2 = position.value) != null ? _a2 : NaN,
        currency: (_b = position.currency.isoCode) != null ? _b : null,
        gainLossRelative: (_c = position.profitLoss.potential.relative) != null ? _c : null,
        sector: sectorName
      };
    }).filter((position) => {
      return payload.breakdownType === "sector" ? position.assetClass === "stock" : true;
    });
  }
  getPortfolioTotal(payload) {
    const positions = this.getPortfolioPositions(payload);
    return positions.reduce((sum, position) => sum + position.marketValue, 0);
  }
  getUniqueGroupValues(payload) {
    const positions = this.getPortfolioPositions(payload);
    const groupValues = positions.map((position) => {
      var _a;
      return (_a = position[payload.breakdownType]) != null ? _a : "";
    });
    return [...new Set(groupValues)];
  }
  getBreakdowns(payload) {
    const uniqueGroupValues = this.getUniqueGroupValues(payload);
    return uniqueGroupValues.map((groupValue) => this.getBreakdown(payload, groupValue));
  }
  getBreakdown(payload, groupValue) {
    const positions = this.getPortfolioPositions(payload);
    const portfolioTotal = this.getPortfolioTotal(payload);
    let valueRelative = 0;
    positions.forEach((position) => {
      if (position[payload.breakdownType] === groupValue) {
        valueRelative += position.marketValue;
      }
    });
    return {
      name: groupValue,
      valueRelative: getPercentage(valueRelative, portfolioTotal)
    };
  }
  getResponseData(payload) {
    const breakdowns = this.getBreakdowns(payload);
    return breakdowns.sort((a, b) => {
      var _a, _b;
      return ((_a = a.valueRelative) != null ? _a : 0) < ((_b = b.valueRelative) != null ? _b : 0) ? 1 : -1;
    });
  }
  getResponse(payload) {
    return {
      data: this.getResponseData(payload)
    };
  }
  async updatePortfolioPositionList(payload) {
    try {
      const request = this.getPortfolioPositionListRequest(payload.id);
      return this.getEndpoints().portfolioPositionList.updateState(request);
    } catch (error) {
      this.logger.error(error);
      return false;
    }
  }
  async updateInstrumentGetByNotation(payload, position) {
    try {
      const idNotation = this.getNotationId(position);
      const request = this.getInstrumentGetByNotationRequest(idNotation, payload.language);
      return this.getEndpoints().instrumentGetByNotation.updateState(request);
    } catch (error) {
      this.logger.error(error);
      return false;
    }
  }
  async updateInstrumentCategoryList(payload, position) {
    try {
      const instrumentId = this.getPositionInstrumentId(position);
      const request = this.getInstrumentCategoryListRequest(instrumentId, payload.language);
      return this.getEndpoints().instrumentCategoryList.updateState(request);
    } catch (error) {
      this.logger.error(error);
      return false;
    }
  }
  positionIsStock(payload, position) {
    const instrumentData = this.getInstrumentGetByNotationData(payload, position);
    const code = instrumentData == null ? void 0 : instrumentData.assetClass.code;
    const assetClass = mapAssetClass(code);
    return assetClass === "stock";
  }
  async updateComponentsInputs(payload) {
    var _a, _b;
    let isResponseSuccessful = true;
    try {
      await this.updatePortfolioPositionList(payload);
      const portfolioPositionListData = this.getPortfolioPositionListData(payload);
      await Promise.all([...((_a = portfolioPositionListData == null ? void 0 : portfolioPositionListData.positions) != null ? _a : []).map(async (position) => this.updateInstrumentGetByNotation(payload, position))]);
      if (payload.breakdownType === "sector") {
        const filteredPositions = ((_b = portfolioPositionListData == null ? void 0 : portfolioPositionListData.positions) != null ? _b : []).filter((position) => this.positionIsStock(payload, position));
        await Promise.all([...filteredPositions.map(async (position) => this.updateInstrumentCategoryList(payload, position))]);
      }
    } catch (error) {
      isResponseSuccessful = false;
      this.logger.error(error);
    }
    return isResponseSuccessful;
  }
  async cleanUp(payload) {
    return Promise.resolve(true);
  }
  getEndpoints() {
    var _a;
    if (!this.endpoints) {
      const endpointConfiguration = (_a = this.options) == null ? void 0 : _a.endpointConfiguration;
      this.endpoints = {
        portfolioPositionList: this.getModuleEntity(PortfolioPositionListModuleFactory, getEndpointOptions(endpointConfiguration, "instrumentCategoryList")),
        instrumentGetByNotation: this.getModuleEntity(InstrumentGetByNotationModuleFactory, getEndpointOptions(endpointConfiguration, "instrumentCategoryList")),
        portfolioGet: this.getModuleEntity(PortfolioGetModuleFactory, getEndpointOptions(endpointConfiguration, "instrumentCategoryList")),
        instrumentCategoryList: this.getModuleEntity(InstrumentCategoryListModuleFactory, getEndpointOptions(endpointConfiguration, "instrumentCategoryList"))
      };
    }
    return this.endpoints;
  }
}

export { PortfolioBreakdownStoreModuleFactory };
